<p-sidebar [(visible)]="showExportSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="changedVisibleExportSidebar(false)"
           [style]="{width:'580px'}">
    <ng-template pTemplate="header">Export data</ng-template>

    <div class="flex flex-column mt-2">
        <label class="export-data-label mb-2">File Type</label>
        <p-dropdown [options]="ExportFileTypeModel.ExportFileTypes" placeholder="Please Select" optionLabel="name" optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
    </div>
    <div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
        <button class="btn-darkblue" pButton label="Download" (click)="export()"></button>
    </div>
</p-sidebar>

<p-dialog header="Import" [(visible)]="isActiveImportModal" [style]="{ width: '40rem' }">
    <div class="flex items-center gap-4 mb-4">
        <p-fileUpload #fu mode="basic" chooseLabel="Choose file" chooseIcon="pi pi-upload" accept=".xls,.xlsx" maxFileSize="1000000"
                      (onClear)="onImportFileClear()"
                      (onSelect)="onImportFileSelect($event)"></p-fileUpload>
    </div>
    <div class="error-message mb-3" *ngIf="errorMessageImport" [innerHTML]="errorMessageImport"></div>
    <div class="flex justify-content-end gap-2 mb-2">
        <p-button label="Clear" severity="secondary"
                  [disabled]="importFile === null"
                  (click)="fileUploader.clear()" />

        <p-button label="Import" severity="success"
                  [loading]="loadingImportData"
                  [disabled]="!importFileSelected"
                  (click)="saveImportFile()" />
    </div>
</p-dialog>

<p-dialog
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [resizable]="false"
        [(visible)]="exportLoading"
        [style]="{ width: '425px', height: '215px' }">
    <ng-template pTemplate="header">
        <span class="dialog-header">Downloading data</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="dialog-txt text-small-normal" style="margin-top: -13px">Please wait while we preparing the data</div>
        <div class="mt-4 spinner"></div>
    </ng-template>
</p-dialog>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic}">
    <p-toast></p-toast>

    <p-sidebar [(visible)]="visibleActiveOrdersFilter" position="right" [baseZIndex]="10000">
        <ng-template pTemplate="header">Filter</ng-template>
        <active-orders-filter [_minRangeValue]="minRangeValue" [_maxRangeValue]="maxRangeValue" [activeOrdersComponent]="this"></active-orders-filter>
    </p-sidebar>

    <booking-detail *ngIf="showDetailOrderSideBar"
                    [_orderId]="orderId"
                    [_riderId]="driverId"
                    [_selectedOrder]="selectedOrder"
                    (changedVisibleDisplayOrderDetailEmit)="changedShowDetailOrderSideBarEmit($event)"
                    [_isVisibleDisplayOrderDetail]="showDetailOrderSideBar"></booking-detail>

    <p-tabMenu class="mb-5" [model]="menuTabItems" (activeItemChange)="changeBookingTabMenuActive($event)" [activeItem]="activeTabItem"></p-tabMenu>
    <div class="mb-3"></div>

    <div class="card">
        <!-- Table -->
        <p-table #xpressUsersGrid
                 [columns]="selectedColumns"
                 [value]="deliveryOrders"
                 [lazy]="true"
                 responsiveLayout="auto"
                 selectionMode="single"
                 dataKey="Id"
                 [loading]="loading"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [loading]="loading"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [showFirstLastIcon]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(76vh)'}">
            <ng-template pTemplate="caption">                
                <div class="flex flex-row active-orders_table-head">
                    <div class="active-orders_table-head-fleft">
                        <div class="ml-3 mt-2 mb-2 table-header">Bookings</div>
                    </div>
                    <div class="flex flex-row active-orders_table-head-right">
                        <p-calendar [(ngModel)]="filter.startDate" class="mr-4" dateFormat="'From': dd-M-yy" placeholder="From:"
                                    [maxDate]="filter.endDate" (ngModelChange)="onChangeHeaderFilterDropDown('StartDate', null)"></p-calendar>

                        <p-calendar [(ngModel)]="filter.endDate" class="mr-4" dateFormat="'To': dd-M-yy" placeholder="To:"
                                    [minDate]="filter.startDate" (ngModelChange)="onChangeHeaderFilterDropDown('EndDate', null)"></p-calendar>

                        <div *ngIf="bookingTabMenuActive === bookingTabMenuEnum.Hailed && canImportHailedOrders">
                            <img class="btn-icon" src="Content/xpress-app/images/operator/signup/file-import.svg" alt='' height="14" width="14">
                            <div pButton class="btn-revenue-export btn-import" (click)="showImportModal()">Import</div>
                        </div>
                        <div *ngIf="!isLGUAdmin" class="ml-3">
                            <img class="btn-icon" src="Content/xpress-app/images/operator/signup/upload_files.svg" alt='' height="14" width="14">
                            <div pRipple class="btn-revenue-export" [ngClass]="{'btn-disabled': !canContinue() }" (click)="showSidebar()">Export Data</div>
                        </div>
                        <column-selector #columnSelector class="ml-3 mr-4"
                                         [btnHeight]="41"
                                         [defaultColumns]="selectedColumns"
                                         (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                         [tableName]="OpsTowerMenuEnum[app.opsRoot.activeMenu]+'-'+BookingTabMenuEnum[bookingTabMenuActive]"
                                         [(selectedColumns)]="selectedColumns">
                        </column-selector>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of selectedColumns"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="transactions-column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of this.selectedColumns">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="activeOrdersHeaderSearch[filter.model]"
                                       (input)="handleFilterChange(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{filter.placeholder}}" [(ngModel)]="activeOrdersHeaderSearch[filter.model]"
                                               (ngModelChange)="handleFilterChange(filter.field, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="filter.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" [(ngModel)]="activeOrdersHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="activeOrdersHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="activeOrdersHeaderSearch[filter.model]"
                                            [showIcon]="true"
                                            placeholder="{{filter.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.CalendarTime">
                                <p-calendar [(ngModel)]="activeOrdersHeaderSearch[filter.model]"
                                            [timeOnly]="true"
                                            [showIcon]="true"
                                            hourFormat="12"
                                            placeholder="{{filter.placeholder}}"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-deliveryOrder>
                <tr>
                    <td *ngFor="let col of selectedColumns" [pSelectableRow]="deliveryOrder" class="ui-resizable-column" (click)="openActiveOrderDetail(deliveryOrder)">
                        <ng-container [ngSwitch]="col.field">
                            <ng-container *ngSwitchCase="'StatusText'" class="ui-resizable-column">
                                <span [ngStyle]="OrderUtils.getOrderStatusStyles(deliveryOrder.StatusId)"
                                      class="ui-resizable-column onbg-status-col">
                                    {{OrderUtils.getStatusDisplayText(deliveryOrder.StatusText)}}
                                </span>
                            </ng-container>

                            <ng-container *ngSwitchCase="'BookingLabel'" class="ui-resizable-column">
                                <span *ngIf="deliveryOrder.BookingLabel === 'B2B'"
                                      style="background-color: #004060; color: #FFFFFF;"
                                      class="ui-resizable-column onbg-status-col">
                                    {{OrderUtils.getBookingLabelDisplayText(deliveryOrder.BookingLabel)}}
                                </span>
                                <span *ngIf="deliveryOrder.BookingLabel === 'Primary'"
                                      style="background-color: #A1BDCA; color: #004060;"
                                      class="ui-resizable-column onbg-status-col">
                                    {{deliveryOrder.BookingLabel}}
                                </span>
                            </ng-container>

                            <ng-container *ngSwitchCase="'PickupLocation'" class="ui-resizable-column">
                                <div class="pickup-location-container">
                                    <div>
                                        {{deliveryOrder.PickupLocationBuildingName || '(No Place Name)'}}
                                    </div>
                                    <div class="pickup-location-address">
                                        {{deliveryOrder.PickupLocation}}
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'DropOffLocation'" class="ui-resizable-column">
                                <div class="pickup-location-container">
                                    <div>
                                        {{deliveryOrder.DropOffLocationBuildingName || '(No Place Name)'}}
                                    </div>
                                    <div class="pickup-location-address">
                                        {{deliveryOrder.DropOffLocation}}
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngSwitchDefault>{{deliveryOrder[col.field]}}</ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="deliveryOrders.length > 0" class="pl-1">
                    Showing {{first + 1}} to {{first + deliveryOrders.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

